import Vue from 'vue'
import { TippyComponent } from 'vue-tippy'

import BaseAlert from '../components/Base/BaseAlert'
import BaseCard from '../components/Base/BaseCard'
import BaseIcon from '../components/Base/BaseIcon'
import BaseLink from '../components/Base/BaseLink'
import BaseModal from '../components/Base/BaseModal'
import BaseModalSmall from '../components/Base/BaseModalSmall'
import BaseSideNavigation from '../components/Base/BaseSideNavigation'
import BaseTippy from '../components/Base/BaseTippy'
import BaseToastr from '../components/Base/BaseToastr'
import {
  BaseButton, BaseButtonIcon, BaseButtonLight, BaseButtonSimple
} from '../components/Base/Buttons/buttons'
import {
  BaseInput,
  BaseInputCheckbox,
  BaseInputNumber,
  BaseInputRadio,
  BaseLabel,
  BaseSelect,
  BaseTextArea
} from '../components/Base/Inputs/inputs'
import { BaseTable, BaseTableMultiple } from '../components/Base/Table/table'
import { BaseH1, BaseH2 } from '../components/Base/Titles/titles'

/** LOAD GLOBAL COMPONENTS */
Vue.component('lib-tippy', TippyComponent)
Vue.component('base-card', BaseCard)
Vue.component('base-table', BaseTable)
Vue.component('base-table-multiple', BaseTableMultiple)
Vue.component('base-alert', BaseAlert)
Vue.component('base-h1', BaseH1)
Vue.component('base-h2', BaseH2)
Vue.component('base-icon', BaseIcon)
Vue.component('base-label', BaseLabel)
Vue.component('base-input-number', BaseInputNumber)
Vue.component('base-input-radio', BaseInputRadio)
Vue.component('base-input-checkbox', BaseInputCheckbox)
Vue.component('base-textarea', BaseTextArea)
Vue.component('base-link', BaseLink)
Vue.component('base-button', BaseButton)
Vue.component('base-button-icon', BaseButtonIcon)
Vue.component('base-modal', BaseModal)
Vue.component('base-button-light', BaseButtonLight)
Vue.component('base-button-simple', BaseButtonSimple)
Vue.component('base-input', BaseInput)
Vue.component('base-select', BaseSelect)
Vue.component('base-modal-small', BaseModalSmall)
Vue.component('base-tippy', BaseTippy)
Vue.component('base-toastr', BaseToastr)
Vue.component('base-side-navigation', BaseSideNavigation)

export { Vue }
